import { Checkbox, FormControlLabel } from "@mui/material";
import { useFormikContext } from "formik";
import { AddSolutionFormValues } from "../../add/form/types";
import { EditSolutionFormValues } from "../../edit/form/types";

function CarbonOffsetCheckbox() {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();

  return (
    <FormControlLabel
      control={
        <Checkbox
          id="solution-is-carbon-offset"
          checked={context.values["solution-is-carbon-offset"]}
          onChange={context.handleChange}
          slotProps={{
            input: { "aria-label": "Used for Carbon Offsetting" },
          }}
        />
      }
      label="Used for Carbon Offsetting"
    />
  );
}

export default CarbonOffsetCheckbox;
